import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity'
import { createReducer, on, Action } from '@ngrx/store'

import * as CustomerPaymentMethodsActions from './customer-payment-methods.actions'
import { CustomerPaymentMethodsEntity } from './customer-payment-methods.models'
import { HttpErrorResponse } from '@angular/common/http'

export const CUSTOMER_PAYMENT_METHODS_FEATURE_KEY = 'customerPaymentMethods'

export interface CustomerPaymentMethodsState extends EntityState<CustomerPaymentMethodsEntity> {
  loaded: boolean // has the CustomerPaymentMethods list been loaded
  error?: HttpErrorResponse | null // last known error (if any)
}

export interface CustomerPaymentMethodsPartialState {
  readonly [CUSTOMER_PAYMENT_METHODS_FEATURE_KEY]: CustomerPaymentMethodsState
}

export const customerPaymentMethodsAdapter: EntityAdapter<CustomerPaymentMethodsEntity> =
  createEntityAdapter<CustomerPaymentMethodsEntity>()

export const initialCustomerPaymentMethodsState: CustomerPaymentMethodsState =
  customerPaymentMethodsAdapter.getInitialState({
    // set initial required properties
    loaded: false,
  })

const reducer = createReducer(
  initialCustomerPaymentMethodsState,
  on(CustomerPaymentMethodsActions.loadCustomerPaymentMethods, (state) => ({ ...state, loaded: false, error: null })),
  on(CustomerPaymentMethodsActions.loadCustomerPaymentMethodsSuccess, (state, { customerPaymentMethods }) =>
    customerPaymentMethodsAdapter.setAll(customerPaymentMethods, { ...state, loaded: true }),
  ),
  on(CustomerPaymentMethodsActions.loadCustomerPaymentMethodsFailure, (state, { error }) => ({ ...state, error })),
  on(CustomerPaymentMethodsActions.clearCustomerPaymentMethods, () => ({ ...initialCustomerPaymentMethodsState })),
)

export function customerPaymentMethodsReducer(state: CustomerPaymentMethodsState | undefined, action: Action) {
  return reducer(state, action)
}
